export const GROWTH_SCOUT_API_BASE =
  process.env.REACT_APP_GROWTH_SCOUT_API_BASE ||
  'https://us-central1-ubunifu-college.cloudfunctions.net/growthScoutApi';

export const GROWTH_CATEGORIES = [
  {value: 'partnership', label: 'Partnerships'},
  {value: 'competition', label: 'Competitions'},
  {value: 'funding_lead', label: 'Funding Leads'},
  {value: 'acquisition_lead', label: 'Acquisition Leads'},
];

export const GROWTH_STATUSES = [
  {value: 'new', label: 'New'},
  {value: 'reviewing', label: 'Reviewing'},
  {value: 'qualified', label: 'Qualified'},
  {value: 'contacted', label: 'Contacted'},
  {value: 'watchlist', label: 'Watchlist'},
  {value: 'closed', label: 'Closed'},
  {value: 'ignored', label: 'Ignored'},
];

export const DEFAULT_GROWTH_CONFIG = {
  categories: GROWTH_CATEGORIES.map((item) => item.value),
  countryFocus: 'Kenya',
  includeEastAfrica: true,
  webResultsPerCategory: 10,
  linkedinPagesPerCategory: 1,
  minGrowthScore: 42,
  maxNewPerRun: 40,
};

export const formatGrowthDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return `${date.toLocaleDateString()} | ${date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  })}`;
};

export const formatGrowthDate = (value) => {
  if (!value) return 'Unknown';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString();
};

export const formatGrowthLabel = (value) => String(value || '')
  .split(/[_\s]+/)
  .filter(Boolean)
  .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
  .join(' ');

export const parseGrowthResponse = async (response) => {
  const text = await response.text();
  let data = {};

  if (text) {
    try {
      data = JSON.parse(text);
    } catch (error) {
      data = {error: text};
    }
  }

  if (!response.ok) {
    throw new Error(data.error || data.message || `Request failed with status ${response.status}`);
  }

  return data;
};

export const fetchGrowthScoutWithAuth = async (auth, path, options = {}) => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('You need to be signed in to use Growth Scout.');
  }

  const token = await currentUser.getIdToken();
  const response = await fetch(`${GROWTH_SCOUT_API_BASE}${path}`, {
    method: options.method || 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    body: options.body ? JSON.stringify(options.body) : undefined,
  });

  return parseGrowthResponse(response);
};
